import { Injectable, inject, computed } from '@angular/core';
import { ModuleTerminologyService } from './module-terminology.service';

export interface TasksTerminology {
  nav_label: string;
  singular: string;
  plural: string;
}

/**
 * What the Tasks module is called.
 *
 * A thin wrapper over {@link ModuleTerminologyService}, which holds the naming for every module
 * and stores it PER TENANT on the server. This shape is kept so existing consumers need no changes.
 */
@Injectable({ providedIn: 'root' })
export class TasksTerminologyService {
  private readonly modules = inject(ModuleTerminologyService);

  /** Signal so templates repaint the moment a rename is saved. */
  readonly terminology = computed<TasksTerminology>(() => this.modules.for('tasks')());

  async set(value: TasksTerminology): Promise<void> {
    await this.modules.save('tasks', value);
  }
}
